module.exports = __webpack_public_path__ + "img/logo.4139b582.png";